import React, { useState, useRef, useEffect } from "react";
import Chatbot from "../assets/Chatbot.jpg";
import Bot from "../assets/Profile_Picture.jpg";
import User from "../assets/ChatUser.png"; 
import {  toast } from 'react-toastify';

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [typingDots, setTypingDots] = useState('');
  
  const [hovered, setHovered] = useState(false);
  const [position, setPosition] = useState({
    x: window.innerWidth < 768 ? window.innerWidth - 80 : window.outerWidth - 1350,
    y: window.innerWidth < 768 ? window.innerHeight - 100 : 55,
  });
  const [messages, setMessages] = useState([
    {
      type: "bot",
      text: "Hi you are conversing with Sachin. We can chat anything about my expertise, what would you like to know about me today?",
    },
  ]);
  const [input, setInput] = useState("");
  const [isSending, setIsSending] = useState(false);

  const dragging = useRef(false);
  const offset = useRef({ x: 0, y: 0 });
  const chatEndRef = useRef(null);

  useEffect(() => {
    if (!isTyping) {
      setTypingDots('');
      return;
    }
  
    let dotCount = 0;
    const interval = setInterval(() => {
      dotCount = (dotCount + 1) % 4;
      setTypingDots('.'.repeat(dotCount));
    }, 500);
  
    return () => clearInterval(interval);
  }, [isTyping]);
  

  useEffect(() => {
    window.addEventListener("resize", () => {
      setPosition((pos) => ({
        x: Math.min(pos.x, window.innerWidth - 60),
        y: Math.min(pos.y, window.innerHeight - 60),
      }));
    });
    return () => window.removeEventListener("resize", () => {});
  }, []);

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);
  

  const onMouseDown = (e) => {
    dragging.current = true;
    offset.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
    e.preventDefault();
  };

  const onMouseMove = (e) => {
    if (!dragging.current) return;
    let newX = e.clientX - offset.current.x;
    let newY = e.clientY - offset.current.y;
    newX = Math.max(0, Math.min(newX, window.innerWidth - 60));
    newY = Math.max(0, Math.min(newY, window.innerHeight - 60));
    setPosition({ x: newX, y: newY });
  };

  const onMouseUp = () => {
    dragging.current = false;
  };

  const toggleChat = () => setIsOpen((open) => !open);

  const handleSend = async () => {
    const sessionId = localStorage.getItem("session_id");
  
    if (!input.trim()) return;
  
    const newMessage = { type: "user", text: input };
    setMessages((prev) => [...prev, newMessage]);
    setInput("");
    setIsTyping(true); 
  
    try {
      const response = await fetch(`${process.env.REACT_APP_NODE_URL}/chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message: input,
          sessionId,
        }),
      });
  
      if (!response.ok) {
        throw new Error("Session expired or server error");
      }
  
      const data = await response.json();
      setMessages((prev) => [...prev, { type: "bot", text: data }]);
    } catch (error) {
      console.error("Error during fetch:", error);
      toast.error('The session is expired. Please refresh the page!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsTyping(false);
    }
  };
  
  
  return (
    <>
      {/* Floating draggable icon */}
      <div
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={(e) => {
        onMouseUp(e);
        setHovered(false);
      }}
      onClick={() => {
        if (!dragging.current) toggleChat();
      }}
      onMouseEnter={() => setHovered(true)}
      style={{
        position: "fixed",
        top: position.y,
        left: position.x,
        width: 60,
        maxWidth: "100vw",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transform: hovered ? "scale(1.3)" : "scale(1)",   
        transition: "transform 0.2s ease-in-out",   
        cursor: "pointer"       
      }}
    >
      <div
        style={{
          width: 60,
          height: 60,
          borderRadius: "50%",
          backgroundColor: "#9030f0",
          boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 8,
        }}
      >
        <img
          src={Chatbot}
          alt="Chatbot"
          style={{
            width: "120%",
            height: "120%",
            borderRadius: "50%",
            pointerEvents: "none",
            userSelect: "none",
          }}
        />
      </div>
      <span
        style={{
          marginTop: 4,
          fontSize: 12,
          fontFamily: "cursive",
          fontWeight: "bold",
          color: "#9030f0",
          textAlign: "center",
        }}
      >
        Ask&nbsp;about&nbsp;
        <span style={{ color: "#e91e63" }}>Sachin</span>
      </span>
    </div>

      {isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 1090,
          }}
          onClick={() => setIsOpen(false)}
        />
      )}

      {isOpen && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90vw",
            height: "80vh",
            maxWidth: 600,
            maxHeight: 600,
            borderRadius: 12,
            boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
            backgroundColor: "#fff",
            zIndex: 1100,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              backgroundColor: "#9030f0",
              color: "#fff",
              padding: 12,
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>ChatBot</span>
            <span
              style={{
                fontSize: "0.75rem",
                fontWeight: 600,
                background:
                  "linear-gradient(90deg, #00f0ff 0%, #66ccff 50%, #99ddff 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                userSelect: "none",
              }}
            >
              Powered by AI Agents
            </span>
            <button
              onClick={() => setIsOpen(false)}
              style={{
                background: "transparent",
                border: "none",
                color: "#fff",
                fontWeight: "bold",
                fontSize: 22,
                cursor: "pointer",
                padding: 0,
                lineHeight: 1,
              }}
              aria-label="Close chat"
            >
              ×
            </button>
          </div>

          {/* Chat Messages */}
          <div
  style={{
    flex: 1,
    padding: 16,
    overflowY: "auto",
    backgroundColor: "#f0f0f0",
  }}
>
  {messages.map((msg, idx) => (
    <div
      key={idx}
      style={{
        display: "flex",
        justifyContent: msg.type === "bot" ? "flex-end" : "flex-start",
        alignItems: "flex-end",
        marginBottom: 10,
        gap: 10,
      }}
    >
      {msg.type === "user" && (
        <img
          src={User}
          alt="User"
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      )}
      <div
        style={{
          maxWidth: "70%",
          padding: "10px 14px",
          borderRadius: 16,
          backgroundColor: msg.type === "bot" ? "#0b2939" : "#0573ae",
          boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
          fontSize: 15,
          lineHeight: 1.4,
          whiteSpace: "pre-wrap",
          color: "#fff",
        }}
      >
        {msg.text.split('\n').map((line, i) => (
          <p key={i} style={{ margin: 0 }}>{line}</p>
        ))}
      </div>
      {msg.type === "bot" && (
        <img
          src={Bot}
          alt="Bot"
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      )}
    </div>
  ))}
  {isTyping && (
  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginBottom: 10,
      gap: 10,
    }}
  >
    <div
      style={{
        maxWidth: "70%",
        padding: "10px 14px",
        borderRadius: 16,
        backgroundColor: "#0b2939",
        color: "#fff",
        fontSize: 15,
        fontStyle: "italic",
        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
      }}
    >
      {typingDots}
    </div>
    <img
      src={Bot}
      alt="Bot"
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        objectFit: "cover",
      }}
    />
  </div>
)}

  <div ref={chatEndRef} />
</div>


          {/* Input */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              borderTop: "1px solid #ddd",
              padding: 12,
              backgroundColor: "#f9f9f9",
            }}
          >
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Type a message..."
              style={{
                flex: 1,
                fontSize: 16,
                outline: "none",
                border: "none",
                padding: "8px",
                color: '#000',
                borderRadius: 6,
                background: "#fff",
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSend();
              }}
            />
            <button
              onMouseDown={() => setIsSending(true)}
              onMouseUp={() => {
                setIsSending(false);
                handleSend();
              }}
              style={{
                marginLeft: 10,
                padding: "8px 16px",
                border: "none",
                borderRadius: 6,
                background: isSending
                  ? "linear-gradient(45deg, #ff6ec4, #7873f5)"
                  : "#9030f0",
                color: "white",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Ask...
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatBot;
